import { useReducer } from "react";
import { PopUpsData, PopUpsAction } from "../PopUp";

export const usePopUpsReducer = () => {
  const [data, dispatch] = useReducer(
    (data: PopUpsData, action: PopUpsAction): PopUpsData => {
      switch (action.type) {
        case "setPopUpId":
          return { ...data, current: action.id };
        case "setOpen":
          return { ...data, isOpen: action.isOpen };
        default:
          return { ...data } as PopUpsData;
      }
    },
    { current: "", isOpen: false } as PopUpsData
  );
  return { data, dispatch };
};
